import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  FormFieldComponent,
  FormFieldErrorComponent,
  FormFieldLabelComponent,
} from './form-field.component';

const API = [
  FormFieldComponent,
  FormFieldLabelComponent,
  FormFieldErrorComponent,
];

@NgModule({
  declarations: API,
  imports: [CommonModule],
  exports: API,
})
export class FormFieldModule {}
